const default_data = []

function reducer( state = default_data, { type, payload } ){
    switch( type ){
        case 'updateCart': {
            return payload
        }
        default:
            return state
    }
}

export default reducer